module.exports = __webpack_public_path__ + "0270223ca6594de85a57a5a89bb21754.jpg";